module.exports = __webpack_public_path__ + "img/l_r_vid_3_splash.09abb4d8.jpg";